import React, { Component } from 'react';

class Auth extends Component {
  render() {
    return <React.Fragment>{this.props.children}</React.Fragment>;
  }
}
export default Auth;
